import React, { useState, useEffect } from 'react';
import axiosInstance, { fronturl } from '../../../axiosInstance';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import getCookie from '../../../helpers/getCookie';

const buildIframeUrl = (token) => {
  const params = new URLSearchParams({
    adminIframe: '1',
    otpBypass: '1',
  });

  if (token) {
    params.set('bypassToken', token);
  }

  return `${fronturl}${fronturl.includes('?') ? '&' : '?'}${params.toString()}`;
};

const CreateOrderIframe = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isBypassChecking, setIsBypassChecking] = useState(false);
  const [isBypassAllowed, setIsBypassAllowed] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const bypassToken = new URLSearchParams(location.search).get('bypassToken');
  const hasAdminSession = Boolean(getCookie('token'));
  const isInIframe = typeof window !== 'undefined' && window.self !== window.top;

  useEffect(() => {
    let isMounted = true;

    const loadIframeUrl = async () => {
      if (!hasAdminSession) {
        setIframeUrl(buildIframeUrl(bypassToken));
        return;
      }

      try {
        const { data } = await axiosInstance.post('/admin/create-order-link');
        if (isMounted) {
          setIframeUrl(buildIframeUrl(data?.token || bypassToken));
        }
      } catch (error) {
        if (isMounted) {
          setIframeUrl(buildIframeUrl(bypassToken));
        }
      }
    };

    loadIframeUrl();

    return () => {
      isMounted = false;
    };
  }, [bypassToken, hasAdminSession]);

  useEffect(() => {
    let isMounted = true;

    const verifyBypass = async () => {
    if (!bypassToken || !isInIframe) {
      return;
    }

      setIsBypassChecking(true);
      try {
        const { data } = await axiosInstance.post('/admin/verify-create-order-link', {
          token: bypassToken,
        });

        if (!isMounted) {
          return;
        }

        if (data?.success) {
          setIsBypassAllowed(true);
        } else {
          setIsBypassAllowed(false);
        }
      } catch (error) {
        if (isMounted) {
          setIsBypassAllowed(false);
        }
      } finally {
        if (isMounted) {
          setIsBypassChecking(false);
        }
      }
    };

    verifyBypass();

    return () => {
      isMounted = false;
    };
  }, [bypassToken]);

  useEffect(() => {
    if (!bypassToken || isBypassChecking || isBypassAllowed || hasAdminSession) {
      return;
    }

    toast.error('Create Order access denied');
    navigate('/', { replace: true });
  }, [bypassToken, isBypassChecking, isBypassAllowed, hasAdminSession, navigate]);

  if (bypassToken && isBypassChecking && !hasAdminSession && isInIframe) {
    return (
      <main className="content p-4">
        <p>Validating access...</p>
      </main>
    );
  }

  const currentIframeUrl = iframeUrl || (!hasAdminSession ? buildIframeUrl(bypassToken) : '');

  return (
    <>
      {hasAdminSession && <Sidebar />}
      <main className="content">
        {hasAdminSession && <Navbar />}

        <div className="container">
          {currentIframeUrl ? (
            <iframe src={currentIframeUrl} style={{ width: '100%', height: '90vh' }} />
          ) : (
            <p>Loading create order...</p>
          )}
        </div>
      </main>
    </>
  );
}

export default CreateOrderIframe
